export default "__VITE_ASSET__BnNb3i3A__"